import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/views/Main.vue'
import Login from '@/views/Login.vue'
import NotFound from '@/views/NotFound.vue'
import Store from '@/store/index'

import { getToken, removeToken } from '@/utils/utils'

Vue.use(Router)

export const schoolMgmt = {
  path: 'schoolMgmt',
  name: 'schoolMgmt',
  component: () => import(/* webpackChunkName: "schoolMgmt" */ '@/views/SchoolMgmt/SchoolMgmt.vue'),
  meta: {
    routerName: 'schoolMgmt',
    noChild: true,
    rootPage: true,
    menu: true,
  },
  children: [
    {
      path: 'view/:schoolId',
      name: 'viewSchool',
      component: () =>
        import(/* webpackChunkName: "schoolMgmt" */ '@/views/SchoolMgmt/ViewSchool.vue'),
      meta: {
        routerName: 'viewSchool',
      },
    },
    {
      path: 'add',
      name: 'addSchool',
      component: () =>
        import(/* webpackChunkName: "schoolMgmt" */ '@/views/SchoolMgmt/AddSchool.vue'),
      meta: {
        routerName: 'addSchool',
      },
    },
    {
      path: 'edit/:schoolId',
      name: 'editSchool',
      component: () =>
        import(/* webpackChunkName: "schoolMgmt" */ '@/views/SchoolMgmt/EditSchool.vue'),
      meta: {
        routerName: 'editSchool',
      },
    },
  ],
}

export const staffMgmt = {
  path: 'staffMgmt',
  name: 'staffMgmt',
  component: () => import(/* webpackChunkName: "staffMgmt" */ '@/views/StaffMgmt/StaffMgmt.vue'),
  meta: {
    routerName: 'staffMgmt',
    noChild: true,
    rootPage: true,
    menu: true,
  },
}

export const personal = {
  path: 'personal',
  name: 'personal',
  component: () => import(/* webpackChunkName: "personal" */ '@/views/Personal/Personal.vue'),
  hidden: true,
  meta: {
    routerName: 'personal',
    rootPage: true,
  },
}

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    {
      path: '/',
      redirect: { name: 'schoolMgmt' },
      name: 'main',
      component: Main,
      children: [schoolMgmt, staffMgmt, personal],
    },
    {
      path: '/404',
      name: 'notFound',
      component: NotFound,
    },
    {
      path: '*',
      redirect: '/404',
    },
  ],
})

router.beforeEach((to, from, next) => {
  Store.commit('changeForceBack', false)
  if (to.name === 'login') {
    if (getToken()) {
      next({ name: 'schoolMgmt' })
    } else {
      removeToken()
      next()
    }
  } else {
    if (getToken()) {
      next()
    } else {
      next({ name: 'login' })
    }
  }
})

export default router
